"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
exports.default = (function (_a) {
    var _b, _c, _d;
    var id = _a.id, name = _a.name, type = _a.type, label = _a.label, classes = _a.classes, error = _a.error, description = _a.description, children = _a.children, required = _a.required;
    var inputIsCheckboxOrRadio = type === 'checkbox' || type === 'radio';
    var htmlFor = id || name;
    return (react_1.default.createElement("div", { className: classnames_1.default(classes.formItem, (_b = {},
            _b[classes.alignLabelRight] = inputIsCheckboxOrRadio,
            _b)) },
        react_1.default.createElement("div", { className: classnames_1.default(classes.wrapper, (_c = {},
                _c[classes.alignLabelRight] = inputIsCheckboxOrRadio,
                _c)) },
            children,
            label && (react_1.default.createElement("label", { className: classnames_1.default(classes.label, (_d = {},
                    _d[classes.required] = required,
                    _d[classes.error] = error,
                    _d)), htmlFor: htmlFor }, label))),
        error && (react_1.default.createElement("p", { "data-element": "form-item-error", className: classnames_1.default(classes.error, classes.errorLabel) }, error)),
        description && react_1.default.createElement("p", { className: classes.description }, description)));
});
//# sourceMappingURL=FormItem.js.map